import CssBaseline from '@mui/material/CssBaseline';
import { createTheme, ThemeProvider, ThemeOptions } from '@mui/material/styles';
import { ReactNode } from 'react';

import darkPalette from './dark-palette';
import energeticPalette from './energetic-palette';
import freshPalette from './fresh-palette';
import lightPalette from './light-palette';
import naturalPalette from './natural-palette';
import { componentOverrides } from './overrides';
import serenePalette from './serene-palette';
import trustfulPalette from './trustful-palette';
import createTypography from './typography';

const defaultTheme = createTheme();

const lightThemeOptions: ThemeOptions = {
  palette: lightPalette,
  typography: createTypography(defaultTheme),
};

const darkThemeOptions: ThemeOptions = {
  palette: darkPalette,
  typography: createTypography(defaultTheme),
};

const trustfulThemeOption: ThemeOptions = {
  palette: trustfulPalette,
  typography: createTypography(defaultTheme),
};

const energeticThemeOption: ThemeOptions = {
  palette: energeticPalette,
  typography: createTypography(defaultTheme),
};

const naturalThemeOption: ThemeOptions = {
  palette: naturalPalette,
  typography: createTypography(defaultTheme),
};

const sereneThemeOption: ThemeOptions = {
  palette: serenePalette,
  typography: createTypography(defaultTheme),
};

const freshThemeOption: ThemeOptions = {
  palette: freshPalette,
  typography: createTypography(defaultTheme),
};

function buildTheme(options: ThemeOptions) {
  const base = createTheme(defaultTheme, options);

  return createTheme(base, { components: componentOverrides(base) });
}

const lightTheme = buildTheme(lightThemeOptions);
const darkTheme = buildTheme(darkThemeOptions);
const trustfulTheme = buildTheme(trustfulThemeOption);
const energeticTheme = buildTheme(energeticThemeOption);
const naturalTheme = buildTheme(naturalThemeOption);
const sereneTheme = buildTheme(sereneThemeOption);
const freshTheme = buildTheme(freshThemeOption);

export {
  lightTheme,
  darkTheme,
  trustfulTheme,
  energeticTheme,
  naturalTheme,
  sereneTheme,
  freshTheme,
};

export function lightThemeConfig({ children }: { children: ReactNode }) {
  return (
    <ThemeProvider theme={lightTheme}>
      <CssBaseline />
      {children}
    </ThemeProvider>
  );
}

export function darkThemeConfig({ children }: { children: ReactNode }) {
  return (
    <ThemeProvider theme={darkTheme}>
      <CssBaseline />
      {children}
    </ThemeProvider>
  );
}

export function trustfulThemeConfig({ children }: { children: ReactNode }) {
  return (
    <ThemeProvider theme={trustfulTheme}>
      <CssBaseline />
      {children}
    </ThemeProvider>
  );
}

export function energeticThemeConfig({ children }: { children: ReactNode }) {
  return (
    <ThemeProvider theme={energeticTheme}>
      <CssBaseline />
      {children}
    </ThemeProvider>
  );
}

export function naturalThemeConfig({ children }: { children: ReactNode }) {
  return (
    <ThemeProvider theme={naturalTheme}>
      <CssBaseline />
      {children}
    </ThemeProvider>
  );
}

export function sereneThemeConfig({ children }: { children: ReactNode }) {
  return (
    <ThemeProvider theme={sereneTheme}>
      <CssBaseline />
      {children}
    </ThemeProvider>
  );
}

export function freshThemeConfig({ children }: { children: ReactNode }) {
  return (
    <ThemeProvider theme={freshTheme}>
      <CssBaseline />
      {children}
    </ThemeProvider>
  );
}
